export const formatJobAddress = (job: {
  address1?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
}): string => {
  const parts = [
    job.address1,
    job.city,
    [job.state, job.zip].filter(Boolean).join(' '),
  ].filter(p => p && String(p).trim().length > 0);
  return parts.join(', ');
};
